<template>
    <div style="font-size: 13px">
        <v-row class="no-frame">
            <v-col class="no-frame col-12 contract-info" v-if="isFrequency">
                <span class="secondary--text" >Zahlung</span>
                <span class="ml-1" style="font-weight: 600">{{ frequency }}</span>
                <span class="secondary--text ml-1" v-if="deadline" v-html="deadline"></span>
            </v-col>
            <v-col class="no-frame col-12 contract-info" v-if="!isFrequency">
                <span class="secondary--text" >Zahlung</span>
                <span class="ml-1" style="font-weight: 600">nicht festgelegt</span>
            </v-col>
        </v-row>
        <v-row class="no-frame">
            <v-col class="no-frame col-12 contract-info" v-if="isToc">
                <span class="secondary--text">Kündigungsfrist</span>
                <span class="ml-1 secondary--text">{{ toc }}</span>
            </v-col>
            <v-col class="no-frame col-12 contract-info" v-if="!isToc">
                <span class="secondary--text">Kündigungsfrist</span>
                <span class="ml-1" style="font-weight: 600">nicht festgelegt</span>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import Msd from "@/modules/msd/common/service/Msd";

export default {
    name: "PContractCondition",

    props: {
        contract: {

        }
    },

    computed: {
        months () {
            return this.$store.getters.month;
        },

        deadline () {
            if (this.contract.invoiceFrequency && this.contract.invoiceFrequency.id !== 1) {
                const deadline = Msd.contract.mnt.deadlines(this.contract, this.months);
                return "am " + (deadline ? deadline : "<b style='color:black'>nicht festgelegt</b>")
            }

            return "";
        },

        isFrequency () {
            return this.contract.invoiceFrequency;
        },

        frequency () {
            let frequency = "";

            if (this.isFrequency) {
                frequency = this.contract.invoiceFrequency.name;

                if (this.contract.invoiceInAdvance) {
                    frequency = frequency + " im Voraus"
                }
            } else {
                frequency = "---"
            }

            return frequency;
        },

        isToc () {
            return this.contract.tocMonths && this.contract.tocType;
        },

        toc () {
            let toc = "";

            if (this.isToc) {
                toc = this.contract.tocMonths + " Monate " + this.contract.tocType.name;
                if (this.contract.tocRewal) {
                    toc = toc + ", Verlängerung " + this.contract.tocRenewalDuration + this.contract.renewalType.name
                }
            } else {
                toc = "---"
            }

            return toc;
        }
    },
}
</script>

<style scoped>

.contract-info {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

</style>